const searchResult = {
  br: ({ theme }) => theme.br.normal,
  backgroundColor: ({ theme }) => theme.colors.white,
  labelColor: ({ theme }) => theme.colors.white,
  labelBackgroundColor: ({ theme }) => theme.colors.vattenbla900,
  labelBr: ({ theme }) => theme.br.small,
}

export default searchResult
